import { render, staticRenderFns } from "./WatchTvInstructions.vue?vue&type=template&id=61b3b518&scoped=true&"
import script from "./WatchTvInstructions.vue?vue&type=script&lang=js&"
export * from "./WatchTvInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b3b518",
  null
  
)

export default component.exports